<template>
    <div id="map" class="page pageMap m-mapDR">
        <div class="map-main">
            <el-form v-show="tabIndex == 1" class="page-query" :inline="true" size="mini">
                <el-form-item :label="$t('res.imgName')">
                    <el-input v-model="formSearch.name" :placeholder="$t('tip.name')" clearable></el-input>
                </el-form-item>

                <select-multiple :nameArrays="selectNames"
                        v-on:getViewCountVal="getViewCountVal">
                </select-multiple>

                <el-form-item>
                    <el-button type="primary" @click="getSystemImages(1)" round>{{$t('c.query')}}</el-button>
                    <el-button type="primary" @click="showImg" round>{{$t('res.viewDR')}}</el-button>
                </el-form-item>
            </el-form>

            <div class="page-table">
                <template v-if="userType !== 3 && !neverClickUserTree">
                    <div v-if="tabIndex == 1" class="user-image-tip">
                        <p class="check-node">
                            <i class="icon-folder el-icon-folder-opened"></i>
                            <span v-for="(v, i) in systemNodePostion" :key="i">{{v}}{{i===systemNodePostion.length-1?'':' / '}}</span>
                        </p>
                    </div>
                    <div v-if="tabIndex == 2" v-show="currentCheckNode" class="user-image-tip">
                        <p class="check-node">
                            <i class="icon-folder el-icon-folder-opened"></i>
                            <span v-for="(v, i) in userNodePostion" :key="i">{{v}}{{i===userNodePostion.length-1?'':' / '}}</span>
                        </p>
                    </div>

                    <div class="page-operate">
                        <div class="operate-left">
                            <el-button-group>
                                <el-tooltip class="item" effect="dark" :content="$t('res.checkAll')" placement="top-start" :hide-after="1000">
                                    <el-button size="small" @click="handleCheckAllChange"
                                               :class="[checkAll ? 'btn-active': 'btn-not-active']"
                                               :disabled="listData.length == 0 ? true : false">
                                        <i class="nucfont inuc-checkall"></i>
                                    </el-button>
                                </el-tooltip>

                                <el-tooltip v-show="selectFiles.length > 0" class="item" effect="dark" :content="$t('res.copy')" placement="top-start"
                                            :hide-after="1000">
                                    <el-button size="small" @click="copyMoveImage(false)">
                                        <i class="el-icon-folder-add" style="font-size:18px; font-weight:600"></i>
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip v-show="(tabIndex == 2) && (selectFiles.length > 0)" class="item" effect="dark" :content="$t('res.move')" placement="top-start"
                                            :hide-after="1000">
                                    <el-button size="small" @click="copyMoveImage(true)">
                                        <i class="nucfont inuc-move"></i>
                                    </el-button>
                                </el-tooltip>

                                <el-tooltip v-show="selectFiles.length > 0" class="item" effect="dark" :content="$t('c.delete')" placement="top-start"
                                            :hide-after="1000">
                                    <el-button size="small" @click="deleteImage">
                                        <i class="nucfont inuc-delete"></i>
                                    </el-button>
                                </el-tooltip>
                            </el-button-group>

                            <p v-show="selectFiles.length > 0" class="select-num">
                                {{$t('res.selected', [selectFiles.length])}}
                                <span class="clear-select" @click="resetSelect">{{$t('c.clear')}}</span>
                            </p>
                        </div>

                        <div class="operate-right">
                            <div class="sort-item" :class="{'active': sort.name}" @click="sortChange('name')">
                                <span class="name">名称</span>
                                <i class="order nucfont " v-if="sort.name" :class="sort.name === 'Asc' ? 'inuc-sort-asc1':'inuc-sort-desc1'"></i>
                            </div>
                            <div class="sort-item" :class="{'active': sort.createTime}" @click="sortChange('createTime')">
                                <span class="name">上传时间</span>
                                <i class="order nucfont inuc-sort-asc1" v-if="sort.createTime" :class="sort.createTime === 'Asc' ? 'inuc-sort-asc1':'inuc-sort-desc1'"></i>
                            </div>
                        </div>
                    </div>
                </template>

                <div class="map-list-box">
                    <div class="map-list" v-loading="loading">

                        <el-checkbox-group v-model="selectFiles">
                            <ul>
                                <li class="map-list-outer" v-for="item in listData" :key="item.id" >
                                    <div class="map-item" @click.stop="checkClick" :class="{'active': tabIndex == 1 ? selectFiles.includes(item.id): selectFiles.includes(item.userImageId)}">
                                        <el-checkbox :label="tabIndex == 1 ? item.id:item.userImageId" :title="$t('c.check')">{{ }}</el-checkbox>
                                        <div class="map-detail" :title="item.byName">
                                            <div class="img-wrap">
                                                <img v-if="item.thumbnails[0]" class="map-item-img" :src="item.thumbnails[0].url" alt="map images">
                                            </div>
                                            <p class="map-item-name">{{item.byName}}</p>
                                        </div>

                                        <ul class="operate-list">
                                            <li @click.stop="openFile(item, $event)"><p>{{$t('c.view')}}</p></li>
                                            <li v-if="tabIndex == 1 && userID===item.creator" @click.stop="editImageInfo(item)"><p>{{$t('c.modify')}}</p></li>
                                            <li v-if="tabIndex == 2" @click.stop="editImageInfo(item)"><p>{{$t('c.modify')}}</p></li>
                                        </ul>
                                    </div>
                                </li>
                            </ul>
                        </el-checkbox-group>

                        <!-- 无数据 -->
                        <div v-if="noListData" class="nodata">
                            <i class="nucfont inuc-empty-file"></i>{{$t('c.noData')}}
                        </div>

                        <div v-if="neverClickUserTree" class="need-click-node">
                            <el-empty :description="$t('res.checkNodeTip')" :image-size="220" />
                        </div>
                    </div>
                </div>


                <div class="pagination-bar">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        layout="prev, pager, next, jumper, sizes, total"
                        :total="pagTotal"
                        :page-sizes="[50, 100, 200, 500]"
                        :page-size="pageSize">
                    </el-pagination>
                </div>
            </div>
        </div>
        <el-tabs v-model="tabIndex" type="border-card" class="map-tree" @tab-click="handleClick">
            <el-tab-pane :label="$t('res.standardLib')" class="system-tree" name="1">
                <el-tree
                    ref="fileTree"
                    :data="treeData"
                    node-key="id"
                    :expand-on-click-node="false"
                    :default-expanded-keys="defaultExpandKeys"
                    :filter-node-method="filterNode"
                    @node-click="systemTreeClick"
                >
                    <span class="slot-t-node" slot-scope="{ node, data }"
                          :class="{'current-node': data.id==currentSystemNode.id, 'node-batch': data.type===0}">
                        <i class="nucfont inuc-xitongguanli icon-system" v-if="data.type===0 && data.origin===0"></i>
                        <i class="nucfont inuc-import-user icon-user" v-if="data.type===0 && data.origin===1"></i>
                        <span class="title" :title="data.name">{{treeNodeNameSystem(node,data)}}</span>
                        <span class="tree_node_op" v-if="data.type===0 && data.origin===1">
                            <i class="nucfont inuc-edit" :title="$t('c.edit')" @click.stop="editNode(node,data)"></i>
                        </span>
                   </span>
                </el-tree>

                <el-tooltip class="item" effect="dark" :content="$t('res.updateSystemTree')" placement="top" :hide-after="1000">
                    <span class="tongbu" @click="tongbu" :class="{'loading':tongbuLoading}"><i class="nucfont inuc-tongbu"></i></span>
                </el-tooltip>
            </el-tab-pane>
            <el-tab-pane v-if ="userType !== 3" :label="$t('res.userLib')" class="user-tree" name="2">
                <el-button class="user-tree-add" type="primary" size="mini" @click="appendNode" round>
                    <i class="nucfont inuc-add-circle add-node"></i> {{$t('res.addNode')}}
                </el-button>
                <el-tree
                    ref="userTree"
                    :data="userTreeData"
                    node-key="id"
                    default-expand-all>
                    <span class="slot-t-node" slot-scope="{ node, data }" :class="{'current-node': data.id==currentCheckNode}">
                        <span @click="userTreeClick(node,data)" class="node-name">
                            <span class="folder-type" :class="folderType(data.type)"></span>
                            <span class="title" :title="data.name">{{treeNodeName(node,data)}}</span>
                        </span>
                        <span class="tree_node_op">
                            <i class="nucfont inuc-add-circle" v-if="data.type == 1" :title="$t('c.add')" @click.stop="appendNode(node, data)"></i>
                            <i class="nucfont inuc-share" v-if="data.type == 2" :title="$t('c.share')" @click="shareUserImage(node, data)"></i>
                            <i class="nucfont inuc-edit" v-if="data.type !== 3" :title="$t('c.edit')" @click.stop="editNode(node,data)"></i>
                            <i class="nucfont inuc-remove-circle" v-if="data.children.length == 0" :title="$t('c.delete')" @click="deleteNode(node, data)"></i>
                        </span>

                   </span>
                </el-tree>
            </el-tab-pane>
        </el-tabs>
        <el-dialog :title="isEdit ? $t('res.editNode'):$t('res.addChildNode')"
                :visible.sync="dialogTreeAdd"
                width="510px"
                :close-on-click-modal="true"
                :modal-append-to-body="false"
                @closed="$refs.dialogTree && $refs.dialogTree.resetFields()"
        >
            <el-form  ref="dialogTree"
                    :model="dialogTreeForm"
                    :rules="dialogTreeRule"
                    style="margin-right: 40px"
                    label-width="140px">
                <el-form-item :label="$t('res.nodeName')" prop="name">
                    <el-input v-model="dialogTreeForm.name" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item v-if="!isEdit" :label="$t('res.nodeType')" prop="type">
                    <el-radio-group v-model="dialogTreeForm.type">
                        <el-radio label="1">{{$t('res.file')}}</el-radio>
                        <el-radio label="2">{{$t('res.imgFile')}}</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer" style="text-align: center; margin-top: -10px;">
                <el-button type="primary" @click="saveTreeAdd('dialogTreeForm')">{{$t('c.save')}}</el-button>
            </div>
        </el-dialog>
        <el-dialog :title="isMove ? $t('res.move') : $t('res.copy')"
                :visible.sync="dialogTreeMove"
                width="510px"
                :close-on-click-modal="true"
                :modal-append-to-body="false">
            <p class="choose-tip"><span class="nucfont inuc-exclamation-circle"></span> {{$t('res.selectImgFile')}}</p>
            <el-tree
                    ref="userMoveTree"
                    :data="userTreeData"
                    node-key="id"
                    @node-click="chooseNode"
                    >
                    <span class="slot-t-node" slot-scope="{ node, data }" :class="{'node-disabled': tabIndex==2 && data.id === currentCheckNode}">
                        <span class="node-name copy-move">
                            <span class="folder-type" :class="folderType(data.type)"></span>
                            <span>
                                {{data.type == 3 ?($t('res.shareFrom',{share: data.name})) : (data.type == 2 ?(data.name + ' (' +data.size +')'):data.name)}}
                            </span>
                        </span>
                   </span>
                </el-tree>
            <p class="node-selected">{{$t('system.selected')}}：{{dialogNodePosition.join(' / ')}}</p>
            <div slot="footer" style="text-align: center; margin-top: -10px;">
                <el-button type="primary" :disabled="!nodeSelected.id" :loading="moveLoading"  @click="saveCopyMove">{{$t('c.save')}}</el-button>
            </div>
        </el-dialog>

        <el-dialog
            :title="$t('res.selectMember')"
            :visible.sync="memberDialog"
            width="1000px"
            top="10vh"
            :append-to-body="true"
            :modal-append-to-body="true"
            :close-on-click-modal="true">

            <el-tabs type="border-card" v-model="activeName">
                <el-tab-pane :label="$t('system.allMembers')" name="first">
                    <el-form :inline="true" :model="memberSearch" class="demo-form-inline" size="mini">
                        <el-form-item :label="$t('c.userInfo')">
                            <el-input v-model="memberSearch.search" :placeholder="$t('tip.userSearch')"
                                clearable></el-input>
                        </el-form-item>
                        <select-multi-orgs @orgsChange="orgsChange"></select-multi-orgs>
                        <el-form-item>
                            <el-button type="primary" @click="queryUser" round>{{$t('c.query')}}</el-button>
                        </el-form-item>
                    </el-form>
                    <data-tables class="dialog-table memberTable"
                        ref="userTable"
                        :data="tableData"
                        :table-props="dialogTableProps"
                        :current-page.sync="dialogCurrentPage"
                        :page-size="20"
                        :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                        @select="selectChange"
                        @select-all="selectAllChange"
                    >
                        <!-- column checkbox -->
                        <el-table-column
                            type="selection"
                            width="55px"
                            :reserve-selection="true"
                            align="center">
                        </el-table-column>
                        <el-table-column property="name" :label="$t('c.username')" align="center"
                                show-overflow-tooltip sortable></el-table-column>
                        <el-table-column property="jobNo" :label="$t('c.idNo')" align="center"
                                show-overflow-tooltip sortable></el-table-column>
                        <el-table-column property="accountNo" :label="$t('c.account')" align="center"
                                show-overflow-tooltip sortable></el-table-column>
                        <el-table-column property="typeName" :label="$t('c.occupation')" width="110px" align="center" sortable>
                            <template slot-scope="scope">
                                <span class="type-bg" :class="typeBg(scope.row.type)">{{scope.row.typeName}}</span>
                            </template>
                        </el-table-column>
                        <!-- column title -->
                        <el-table-column v-for="title in dialogTitles" :prop="title.prop" :label="title.label"
                                :key="title.label"
                                align="center"
                                sortable="custom">
                        </el-table-column>
                    </data-tables>
                </el-tab-pane>

                <el-tab-pane :label='selectTableNum' name="second">
                    <data-tables class="dialog-table"
                        :data="multipleSelection"
                        :table-props="dialogTableProps"
                        :page-size="20"
                        :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                    >
                        <!-- column title -->
                        <el-table-column property="name" :label="$t('c.username')" align="center"
                                show-overflow-tooltip sortable></el-table-column>
                        <el-table-column property="jobNo" :label="$t('c.idNo')" align="center"
                                show-overflow-tooltip sortable></el-table-column>
                        <el-table-column property="accountNo" :label="$t('c.account')" align="center"
                                show-overflow-tooltip sortable></el-table-column>
                        <el-table-column property="typeName" :label="$t('c.occupation')" width="110px" align="center" sortable>
                            <template slot-scope="scope">
                                <span class="type-bg" :class="typeBg(scope.row.type)">{{scope.row.typeName}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column v-for="title in dialogTitles" :prop="title.prop" :label="title.label"
                                :key="title.label"
                                align="center"
                                sortable="custom">
                        </el-table-column>
                        <el-table-column :label="$t('c.operation')" align="center">
                            <div class="btn-cell" slot-scope="scope">
                                <i class="nucfont inuc-delete" :title="$t('c.delete')"
                                    @click="handleDelete(scope.$index, scope.row.id)"></i>
                            </div>
                        </el-table-column>
                    </data-tables>
                </el-tab-pane>

            </el-tabs>
            <div slot="footer" style="text-align: center; margin-top: 10px;">
                <el-button type="primary" :disabled="multipleSelection.length == 0" @click="saveUser" :loading="shareLoading">{{$t('c.save')}}</el-button>
            </div>
        </el-dialog>
        <el-dialog
            :title="$t('res.editImg')"
            :visible.sync="editImageDialog"
            width="510px"
            :close-on-click-modal="true"
            :modal-append-to-body="false"
            @closed="$refs.editFormDialog && $refs.editFormDialog.resetFields()"
        >
            <el-form
                :model="editImageForm"
                :rules="editImageRule"
                class="edit-image-form"
                ref="editFormDialog"
                label-width="100px">
                <el-form-item :label="$t('c.name')" prop="byName">
                    <el-input v-model="editImageForm.byName" :placeholder="$t('tip.name')" clearable></el-input>
                </el-form-item>
                <el-form-item :label="$t('c.knowledgePoint')" prop="kp" style="margin-bottom: 20px">
                    <el-cascader
                        v-model="editImageForm.kp"
                        :options="knowledgeData"
                        :props="cascadeProp"
                        :placeholder="$t('tip.knowledgePoint')"
                        :show-all-levels="false"
                        @change="kpChange"
                        filterable
                    ></el-cascader>
                </el-form-item>
                <el-form-item :label="$t('c.description')" prop="description">
                    <el-input type="textarea" v-model="editImageForm.description"
                            :autosize="{ minRows: 3, maxRows: 4}"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" style="text-align: center">
                <el-button type="primary" @click="saveImageEdit" :loading="editLoading">{{$t('c.save')}}</el-button>
            </div>
        </el-dialog>

        <!-- 二级页面 -->
        <map-detail
            ref="mapDetail"
            :isDR="true"
            :subPage.sync="subPage"
            @viewImage="viewDR"
            @editImage="editImageInfo">
        </map-detail>

        <full-screen
            ref="nstswrap"
            :src="src"
            :isShow="isShow"
            :showCloseBtn="false"
            @changeIsShow="toggleIsShow"
        />
    </div>
</template>

<script>
    import api from '@/api'
    import qs from 'qs'
    import {Ticket,Cascade} from '@/utils'
    import FullScreen from '@/components/FullScreen'
    import selectMultiple from '@/components/Selectmultiple'
    import selectMultiOrgs from '@/components/SelectMultiOrgs'
    import MapDetail from "./MapDetail"
    import {mapGetters} from 'vuex'

    export default {
        name: 'MapDr',
        components: {
            FullScreen, selectMultiple, selectMultiOrgs, MapDetail
        },
        data() {
            return {
                // dr-img
                isShow: false,
                src: '',
                tabIndex:'1',
                treeData: [],       //树的数据
                defaultExpandKeys: [],
                listData: [],       //图像数据
                selectFiles: [],    //选择的图像
                currentSystemNode: '',  //当前选中的标准库data
                formSearch: {
                    name: '',
                    viewCount: 0,
                    knowledges: []
                },
                selectNames: [
                    {key: "viewCount"}
                ],
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                loading: false,
                tongbuLoading: false,
                pagTotal: 0,
                currentPage: 1,
                pageSize: 50,
                systemNodePostion: [],

                subPage: false,

                queryParams: {},
                userTreeData: [],
                add_question_flag: false,
                new_question_name: '',
                tree_key: 0,

                currentData: '',
                menuVisible: false,
                firstLevel: false,
                currentDirectoryID: '',
                isEdit: false,
                dialogTreeForm: {
                    name: '',
                    type: '1'
                },
                dialogTreeRule: {
                    name: [
                        {required: true, message: this.$t('tip.name'), trigger: 'blur'},
                        {max: 50, message: this.$t('rule.maxLength', ['50']), trigger: 'blur'}
                    ],
                    type:{required: true}
                },
                dialogTreeAdd: false,
                cascadeProp: {
                    value: 'id',
                    label: 'value',
                    children: 'children'
                },
                isMove: false,
                dialogTreeMove: false,
                nodeSelected: {
                    id: '',
                    name: ''
                },
                shareLoading: false,
                moveLoading: false,
                memberDialog: false,
                memberSearch: {
                    search: '',
                    orgIds: [],
                },
                tableData: [],
                multipleSelection: [],
                dialogTableProps: {
                    border: false,
                    stripe: true,
                    rowKey: row => row.id,
                    height: "40vh"
                },
                dialogCurrentPage: 1,
                dialogTitles: [
                    {
                        prop: 'orgName',
                        label: this.$t('c.organizations')
                    }, {
                        prop: 'postName',
                        label: this.$t('c.position')
                    }, {
                        prop: 'gradeName',
                        label: this.$t('c.grade')
                    }
                ],
                selectedData: [],
                activeName: 'first',
                //用户图像编辑
                editImageForm: {
                    byName: '',
                    kp: [],
                    description: ''
                },
                editImageRule: {
                    byName: [
                        {required: true, message: this.$t('tip.name'), trigger: 'blur'},
                        {max: 100, message: this.$t('rule.maxLength', ['100']), trigger: 'blur'}
                    ],
                    kp: [
                        {required: true, message: this.$t('tip.knowledgePoint'), trigger: 'change'}
                    ],
                    description: [
                        {max: 500, message: this.$t('rule.maxLength', ['500']), trigger: 'blur'},
                    ],
                },
                currentImageID: '',
                editImageDialog: false,
                knowledgeData:[],
                nodeObj:'',
                userNodePostion:[],
                dialogNodePosition:[],
                currentCheckNode:'',

                // 排序
                sort: {
                    name: 'Asc',  // Asc Desc
                    createTime: ''
                }
            }
        },
        computed: {
            ...mapGetters([
                'systemKnowledgeMenu',
            ]),
            userID() {
                return Ticket.get().userID
            },
            userType() {
                return Ticket.get().type
            },
            selectTableNum() {
                return this.$t('system.selectedMember') + `(${this.multipleSelection.length})`
            },
            noListData() {
                if (!this.listData.length) {
                    if (this.tabIndex==1 || (this.tabIndex==2 && this.currentCheckNode)) {
                        return true
                    }
                } else {
                    return false
                }
            },
            // 在个人图库中，还未点击过节点
            neverClickUserTree() {
                return (this.tabIndex==2 && !this.currentCheckNode)
            }
        },
        mounted() {
            this.loading = true

            //标准图库加载
            this.querySystemTree()

            this.queryUserTree()

            this.$store.dispatch('getSystemKnowledgeMenu', {
                type: 'Image',
                includeSafty: true
            }).then(data => {
                this.knowledgeData = data
            })
        },
        methods: {
            filterNode(value, data) {
                return data.size
            },

            //点击tab
            handleClick(tab, event) {
                //this.userNodePostion = []
                //this.currentCheckNode = ''
                this.checkAll = false
                this.selectFiles = []
                this.listData = []
                this.pagTotal = 0

                if (this.tabIndex == 1) {
                    if (!this.currentSystemNode) {
                        $('.system-tree .el-tree > .el-tree-node:eq(0)').find('.el-tree-node__content:eq(0)').click()
                    } else {
                        $('.system-tree .current-node').closest('.el-tree-node').click()
                    }
                } else {
                    this.queryUserTree()
                }
            },

            querySystemTree() {
                return api.getDRSystemTree().then(res => {
                    let data = res.package.children

                    this.treeData = res.package.children

                    this.defaultExpandKeys = []
                    this.treeData.forEach(v => {
                        this.defaultExpandKeys.push(v.id)
                        v.children.forEach(vv => {
                            this.defaultExpandKeys.push(vv.id)
                        })
                    })

                    this.$nextTick(() => {
                        this.$refs.fileTree.filter()

                        if (!this.currentSystemNode) {
                            $('.m-mapDR .system-tree .el-tree > .el-tree-node:eq(0)').find('.el-tree-node__content:eq(0)').click()
                        } else {
                            $('.m-mapDR .system-tree .current-node .node-name').click()
                        }
                    })
                })
            },
            tongbu(e) {
                this.tongbuLoading = true
                this.querySystemTree().then(() => {
                    setTimeout(() => {
                        this.tongbuLoading = false
                    }, 500)
                }).catch(() => this.tongbuLoading = false)
            },

            //查询用户图库目录树
            queryUserTree(){
                api.getDRUserTree().then(res => {
                    this.userTreeData = res.package.children
                    if (this.currentCheckNode) {
                        $('.user-tree .current-node .node-name').click()
                    }
                })
            },

            getSystemImages(num) {
                if (num) this.currentPage = num

                this.queryParams = {
                    batchId: this.currentSystemNode.batchId,
                    knowledge: this.currentSystemNode.kpId,
                    type: this.currentSystemNode.type,
                    pageNO: this.currentPage,
                    limit: this.pageSize,
                    ...this.formSearch
                }

                if (this.sort.name) {
                    this.queryParams.sortName = ''
                    this.queryParams.order = this.sort.name
                }
                if (this.sort.createTime) {
                    this.queryParams.sortName = 'createTime'
                    this.queryParams.order = this.sort.createTime
                }

                if (!this.formSearch.viewCount) delete this.queryParams.viewCount

                api.querySystemDRTree(this.queryParams).then(res => {
                    this.listData = res.package
                    this.pagTotal = res.total

                    this.checkAll = false
                    setTimeout(() => {
                        this.loading = false
                    }, 200)
                })
            },

            //点击用户图像包
            getUserImages(directoryID){
                let queryParams = {
                    pageNO: this.currentPage,
                    limit: this.pageSize,
                }

                if (this.sort.name) {
                    queryParams.sortName = ''
                    queryParams.order = this.sort.name
                }
                if (this.sort.createTime) {
                    queryParams.sortName = 'createTime'
                    queryParams.order = this.sort.createTime
                }

                api.getDRUserImage(directoryID, queryParams).then(res => {
                    this.listData = res.package
                    this.pagTotal = res.total

                    // 清空选中状态
                    this.checkAll = false

                    setTimeout(() => {
                        this.loading = false
                    }, 200)
                })
            },

            systemTreeClick(data, node, e) {
                this.currentSystemNode = data
                this.resetSelect()
                this.getSystemImages(1)
                this.systemNodePostion = []
                this.getSystemTreeParentNode(node)
            },

            userTreeClick (node, data) {
                if(data.type == 2){
                    //this.listData = []
                    this.resetSelect()
                    this.currentCheckNode = data.id
                    this.currentPage = 1
                    this.getUserImages(data.id)
                    this.userNodePostion = []
                    this.getUserTreeParentNode(node)
                }
            },

            openFile(data, e) {
                this.subPage = true
                let id = this.tabIndex == 1 ? data.id : data.userImageId
                this.$refs.mapDetail.getImageDetail(id)
            },

            // 首页图像查看按钮
            showImg() {
                this.queryParams.total = this.pagTotal
                let routeParams = {
                    ...this.queryParams,
                    lang: this.$i18n.locale
                }
                routeParams = qs.stringify(routeParams, { arrayFormat: 'repeat' })
                this.isShow = !this.isShow
                this.src = `${api.imagePanoramicHost}/drLibrary?${routeParams}`
                // this.src = '/static/3D/DR_base.html?type=MAP_BROWSE'
                this.$refs.nstswrap.fullScreen()
            },
            toggleIsShow (val) {
                this.isShow = val
                this.src = null
            },
            viewDR(initShowId) {
                this.queryParams.total = this.pagTotal
                this.queryParams.pageNO = this.currentPage
                this.queryParams.limit = this.pageSize
                // tabIndex === '2' 表示用户图库
                if (this.tabIndex === '2') {
                    this.queryParams.isUserDirectory = true
                    this.queryParams.checkNode = this.currentCheckNode
                }
                let routeParams = {
                    ...this.queryParams,
                    initShowId,
                    lang: this.$i18n.locale
                }
                routeParams = qs.stringify(routeParams, { arrayFormat: 'repeat' })
                this.isShow = !this.isShow
                this.src = `${api.imagePanoramicHost}/drLibrary?${routeParams}`
                // this.src = `/static/3D/DR_base.html?type=MAP_BROWSE&initShowId=${initShowId}`
                this.$refs.nstswrap.fullScreen()
            },

            //修改图库图像名称、知识点、描述
            editImageInfo(data, source){
                this.editImageDialog = true
                this.currentImageID = this.tabIndex == 1 ? data.id : data.userImageId
                this.editImageForm.byName = data.byName
                this.editImageForm.kp =  Cascade.fullPath(this.knowledgeData, data.knowledge)
                this.editImageForm.description = data.description
                this.editImageForm.source = source
            },
            //保存图像修改
            saveImageEdit() {
                this.$refs['editFormDialog'].validate((valid) => {
                    if (!valid) return
                    this.editLoading = true
                    let data ={
                        byName: this.editImageForm.byName,
                        kp: this.editImageForm.kp[this.editImageForm.kp.length-1],
                        description: this.editImageForm.description
                    }

                    let editApi = this.tabIndex == 1 ? api.editDR(this.currentImageID, data):
                                                   api.putUserImage(this.currentImageID, data)

                    editApi.then(res => {
                        this.editImageDialog = false
                        this.editLoading = false
                        this.success(this.$t('m.editSuccess'))

                        // 不论在外面修改还是里面，都需要更新list数据
                        if (this.tabIndex == 1) {
                            this.getSystemImages()
                        } else {
                            this.getUserImages(this.currentCheckNode)
                        }

                        // 在里面修改还需额外更新里面的数据
                        if (this.editImageForm.source) {
                            let $sub = this.$refs.mapDetail
                            $sub.getImageDetail($sub.subData.id)
                        }

                    }).catch(error => this.editLoading = false)
                })
            },

            //删除图像
            deleteImage() {
                if (this.tabIndex == 1) {
                    let delArr = []
                    this.selectFiles.forEach((id,i) => {
                        let item = this.listData.find(v => v.id === id)
                        if (item.creator === this.userID) {
                            delArr.push(id)
                        }
                    })

                    if (!delArr.length) {
                        this.resetSelect()
                        return this.$message.error(this.$t('res.noAccessToDelete'))
                    }

                    let notAllowedNum = this.selectFiles.length - delArr.length
                    let extraText = notAllowedNum!==0? this.$t('res.filterDelete', [notAllowedNum]) : ''

                    this.$confirm(this.$t('m.delete')+extraText, this.$t('m.tip'), {
                        type: 'warning'
                    }).then(() => {
                        api.deleteDRs({ids: delArr}).then(res => {
                            this.success(this.$t('m.delSuccess'))
                            this.resetSelect()
                            this.getSystemImages()
                        });
                    }).catch(() => {});

                } else {

                    this.$confirm(this.$t('m.delete'), this.$t('m.tip'), {
                        type: 'warning'
                    }).then(() => {
                        api.deleteUserImage({userImageIDs: this.selectFiles}).then(res => {
                            this.success(this.$t('m.delSuccess'))
                            this.resetSelect()
                            this.queryUserTree()
                            this.getUserImages(this.currentCheckNode)
                        })
                    }).catch(() => {})
                }
            },

            getViewCountVal(data) {
                this.formSearch.viewCount = data.filter(item => item!==0)
            },
            getImageOriginVal(data) {
                let rst = []
                data.forEach(item => {
                    if (item>0) rst.push(item - 1)
                })
                this.formSearch.origins = rst
            },

            //全选
            handleCheckAllChange(val) {
                if (this.checkAll) {
                    this.selectFiles = []
                    this.checkAll = false
                } else {
                    let newArr = []
                    const idKey = this.tabIndex == 1 ? 'id': 'userImageId'
                    this.listData.forEach((element) => {
                        newArr.push(element[idKey])
                    })
                    this.selectFiles = newArr
                    this.checkAll = true
                }
            },
            //清空选择
            resetSelect() {
                this.selectFiles = []
                this.checkAll = false
            },
            //复制图像
            copyMoveImage(isMove) {
                this.dialogTreeMove = true
                this.dialogNodePosition = []
                this.isMove = isMove
                this.nodeSelected.id = ''
                this.nodeSelected.name = ''
            },
            //选择复制 移动页面图像包节点
            chooseNode(data, node) {
                if (this.tabIndex==2 && data.id === this.currentCheckNode) return
                if (data.type == 2) {
                    this.nodeSelected.id = data.id
                    this.nodeSelected.name = data.name
                    this.dialogNodePosition = []
                    this.getDialogParentNode(node)
                }
            },
            //保存复制或移动
            saveCopyMove() {
                if (this.isMove) {
                    let data = {
                        userImageIDs: this.selectFiles
                    }
                    this.moveLoading = true
                    api.moveUserImage(this.nodeSelected.id, data).then(res => {
			            this.moveLoading = false
                        this.dialogTreeMove = false
                        this.success(this.$t('res.moveSuccess'))
                        //清空选中
                        this.selectFiles = []
                        //重新查询目录树和当前图像列表
                        this.queryUserTree()
                        this.getUserImages(this.currentCheckNode)
                    }).catch(error => this.moveLoading = false)
                } else {
                    if(this.tabIndex == 1){
                        let data = {
                            imageIDs: this.selectFiles
                        }
                        this.moveLoading = true
                        api.copySystemImage(this.nodeSelected.id, data).then(res => {
			                this.moveLoading = false
                            this.dialogTreeMove = false
                            this.success(this.$t('res.copySuccess'))
                            this.resetSelect()
                            api.getDRUserTree().then(res => {
                                this.userTreeData = res.package.children
                            })
                        }).catch(error => this.moveLoading = false)
                    } else {
                        let data = {
                            userImageIDs: this.selectFiles
                        }
                        this.moveLoading = true
                        api.copyUserImage(this.nodeSelected.id, data).then(res => {
			                this.moveLoading = false
                            this.dialogTreeMove = false
                            this.success(this.$t('res.copySuccess'))
                            this.resetSelect()
                            this.queryUserTree()
                        }).catch(error => this.moveLoading = false)
                    }
                }
            },

            getSystemTreeParentNode(node) {
                if (node) {
                    if (node.parent) {
                        this.systemNodePostion.unshift(node.data.name) //在数组头部添加元素
                        this.getSystemTreeParentNode(node.parent) //递归
                    }
                }
            },
            //获取节点父级
            getUserTreeParentNode(node){
                if (node) {
                    if (node.parent) {
                        if(node.data.type == 3){
                            this.userNodePostion.unshift(this.$t('res.shareFrom',{share: node.data.name}))
                        }else{
                            this.userNodePostion.unshift(node.data.name) //在数组头部添加元素
                        }
                        this.getUserTreeParentNode(node.parent) //递归
                    }
                }
            },
            //获取dialog节点父级
            getDialogParentNode(node){
                if (node) {
                    if (node.parent) {
                        if(node.data.type == 3){
                            this.dialogNodePosition.unshift(this.$t('res.shareFrom',{share: node.data.name}))
                        }else{
                            this.dialogNodePosition.unshift(node.data.name) //在数组头部添加元素
                        }
                        this.getDialogParentNode(node.parent) //递归
                    }
                }
            },

             // 增加节点
            appendNode(node, data) {
                this.currentData = ''
                if(data){
                    this.currentData = data
                }
                this.isEdit = false
                this.dialogTreeAdd = true
                this.resetTreeForm()
            },
            //添加或保存用户图库目录树节点
            saveTreeAdd(){
                this.$refs['dialogTree'].validate((valid) => {
                    if (!valid) return
                    if (this.isEdit) {
                        let data = {
                            name: this.dialogTreeForm.name,
                        }

                        if (this.tabIndex == 1) {
                            console.log(this.currentData)
                            api.renameDRBatch(this.currentData.batchId, data).then(res => {
                                this.dialogTreeAdd = false
                                this.success(this.$t('m.editSuccess'))
                                this.treeData.forEach(item => {
                                    if (item.id === this.currentData.id) {
                                        item.name = data.name
                                    }
                                })
                            })
                        } else {
                            api.putUserTree(this.currentData.id, data).then(res => {
                                this.dialogTreeAdd = false
                                this.success(this.$t('m.editSuccess'))
                                this.queryUserTree()
                            })
                        }

                    } else {
                        let data = {
                            superiorID: this.currentData ? this.currentData.id : '',
                            region: 'DR',
                            name: this.dialogTreeForm.name,
                            directoryType: this.dialogTreeForm.type == 1 ? 'SubDirectory' : 'ImagePackage'
                        }
                        api.postUserTree(data).then(res => {
                            this.dialogTreeAdd = false
                            this.success(this.$t('m.addSuccess'))
                            this.queryUserTree()
                        })
                    }
                })
            },
            resetTreeForm(){
                this.dialogTreeForm.name = ''
                this.dialogTreeForm.type = '1'
            },
            // 删除节点
            deleteNode (node, data) {
                let deleteTip = this.$t('m.delete')
                if (data.type == 1){
                    deleteTip = this.$t('res.sureDelFile', {file: data.name})
                } else if(data.type == 2){
                    deleteTip = this.$t('res.sureDelImgFile', {file: data.name})
                }
                this.$confirm(deleteTip, this.$t('m.tip'), {
                    type: 'warning'
                }).then(() => {
                    api.deleteUserTree(data.id).then((res) => {
                        this.$message({
                            type: 'success',
                            message: this.$t('m.delSuccess')
                        })
                        if(data.type ==2 && data.id == this.currentCheckNode){
                            this.listData = []
                            this.pagTotal = 0
                            // 清空选中状态
                            this.selectFiles = []
                            this.currentCheckNode = ''
                        }
                        this.queryUserTree()
                    })
                }).catch(() => {
                })
            },
            // 编辑节点
            editNode (node, data) {
                // debugger
                this.isEdit = true
                this.dialogTreeAdd = true
                this.currentData = data
                this.dialogTreeForm.name = data.name
            },
            //目录节点图标及颜色
            folderType(type){
                let color = 'nucfont '
                switch (type){
                    case 1:
                        color = color + 'inuc-folder folder'
                        break
                    case 2:
                        color = color + 'inuc-wenjianjia_f image'
                        break
                    case 3:
                        color = color + 'inuc-share share'
                        break
                    default:
                        break
                }
                return color
            },

            //知识点变化
            kpChange(data){
                this.editImageForm.kp = data
            },
            //分享图像包
            shareUserImage(node, data){
                this.memberDialog = true
                this.$store.dispatch('getOrgTree')
                this.currentDirectoryID = data.id
                this.multipleSelection = []
                this.memberSearch.search = ''
                this.memberSearch.orgIds = []
                this.queryUser()
                this.$nextTick(()=>{
                    let dialogUserTable = this.$refs.userTable.$refs.elTable
                    dialogUserTable.clearSelection()
                    this.activeName = 'first'
                })
            },
            orgsChange(data) {
                this.memberSearch.orgIds = data
            },
            //查询用户列表
            queryUser(){
                this.dialogCurrentPage = 1
                let queryData = {
                    ...this.memberSearch,
                    types: [1,2]   // 管理员、培训师
                }
                if (!queryData.search) delete queryData.search
                return api.queryUsers(queryData).then(res => {
                    let data = res.package.filter(item => (item.id != this.userID) )
                    data.forEach(item => {
                        item.postName = item.postName ? item.postName : ''
                        item.gradeName = item.gradeName ? item.gradeName : ''
                    })
                    this.tableData = data
                })
            },
            //分享人员保存
            saveUser(){
                let selectedIds = []
                this.multipleSelection.forEach(val => {
                    selectedIds.push(
                        val.id || val.userID
                    )
                })
		        this.shareLoading = true
                api.shareUserImage(this.currentDirectoryID, {targetUser: selectedIds}).then(res => {
                    this.memberDialog = false
                    this.shareLoading = false
                    this.multipleSelection = []
                    this.success(this.$t('res.shareSuccess'))
                }).catch(error => this.shareLoading = false)
            },

            //删除已选人员
            handleDelete(index, id) {
                let idxn = this.multipleSelection.findIndex(val => val.id === id)
                this.multipleSelection.splice(idxn, 1)

                this.$nextTick(() => {
                    let CheckboxElTable=this.$refs.userTable.$refs.elTable
                    let idx = this.tableData.findIndex(val => val.id === id)
                    CheckboxElTable.toggleRowSelection(this.tableData[idx], false)
                })
            },
            selectChange(val) {
                this.multipleSelection = val
            },
            selectAllChange(val) {
                this.multipleSelection = val
            },

            checkClick(e) {
                if (e.target.className === 'el-checkbox__inner') return
                $(e.target).closest('.map-item').find('.el-checkbox input').click()
            },
            // 页码变化
            handleCurrentChange(val) {
                this.currentPage = val
                //this.loading = true
                if(this.tabIndex == 1){
                    this.getSystemImages()
                }else{
                    this.getUserImages(this.currentCheckNode)
                }
            },
            handleSizeChange(val) {
                this.pageSize = val
               // this.loading = true
                if(this.tabIndex == 1){
                    this.getSystemImages()
                }else{
                    this.getUserImages(this.currentCheckNode)
                }
            },

            treeNodeNameSystem(node,data) {
                let nodeName = ''
                switch (node.level){
                    case 1:
                        nodeName = data.name.length > 14 ? (data.name.substring(0,13)+'...'): data.name
                        break
                    case 2:
                        nodeName = data.name.length > 14 ? (data.name.substring(0,13)+'...'): data.name
                        break
                    case 3:
                        nodeName = data.name.length > 12 ? (data.name.substring(0,12)+'...'): data.name
                        break
                    default:
                        nodeName = data.name.length > 12 ? (data.name.substring(0,11)+'...'): data.name
                        break
                }
                nodeName = nodeName + '(' +data.size +')'
                return nodeName
            },
            //用户目录树节点名称
            treeNodeName(node,data){
                let nodeName = ''
                switch (node.level){
                    case 1:
                        nodeName = data.name.length > 14 ? (data.name.substring(0,12)+'...'): data.name
                        break
                    case 2:
                        nodeName = data.name.length > 12 ? (data.name.substring(0,10)+'...'): data.name
                        break
                    case 3:
                        nodeName = data.name.length > 8 ? (data.name.substring(0,6)+'...'): data.name
                        break
                    default:
                        nodeName = data.name.length > 6 ? (data.name.substring(0,4)+'...'): data.name
                        break
                }
                nodeName = data.type == 3 ?(this.$t('res.shareFrom',{share: data.name})) : (data.type == 2 ?(nodeName + '(' +data.size +')'):nodeName)
                return nodeName
            },

            success(msg) {
                this.$message({
                    message: msg,
                    type: 'success'
                })
            },

            sortChange(name) {
                if (name === 'name') {
                    if (!this.sort.name || this.sort.name === 'Desc') {
                        this.sort.name = 'Asc'
                    } else if (this.sort.name === 'Asc') {
                        this.sort.name = 'Desc'
                    }
                    this.sort.createTime = ''
                }

                if (name === 'createTime') {
                    if (!this.sort.createTime || this.sort.createTime === 'Desc') {
                        this.sort.createTime = 'Asc'
                    } else if (this.sort.createTime === 'Asc') {
                        this.sort.createTime = 'Desc'
                    }
                    this.sort.name = ''
                }

                if(this.tabIndex == 1){
                    this.getSystemImages()
                }else{
                    this.getUserImages(this.currentCheckNode)
                }
            },

            typeBg(type){
                let typeColor = ''
                switch (type){
                    case 2:
                        typeColor = 'trainer'
                        break
                    case 3:
                        typeColor = 'student'
                        break
                    case 1:
                        typeColor = 'admin'
                        break
                    default:
                        typeColor = ''
                }
                return typeColor
            }
        },

        beforeDestroy() {
            $(document).off()
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../style/const.scss';

    @include scrollbar();

    .page {
        flex-direction: row;
        font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    }

    .page-query {
        margin-bottom: 0;
        padding-bottom: 0;
    }

    .page-operate {
        display: flex;
        justify-content: space-between;
        padding: 0 10px;
        margin-bottom: 10px;
        .el-button{
            height: 36px;
        }
        .select-num{
            display: inline-block;
            padding-left: 10px;
            color: #666;
            .clear-select {
                padding: 0 10px;
                font-size: 12px;
                color: #1890ff;
                cursor: pointer;
                text-decoration: underline;
            }
        }

        .operate-right {
            display: flex;
            align-items: center;

            .sort-item {
                padding: 4px 5px;
                color: #666;
                cursor: pointer;
                &.active {
                    color: $blue;
                }
            }
        }
    }

    .page-table {
        box-shadow: none;
    }

    .map-main {
        display: flex;
        flex-direction: column;
        flex: 1;
        padding: 20px;
        margin: -20px -20px -20px 0;
        order: 2;
        overflow-x: hidden;
    }

    .map-tree {
        height: 100%;
        width: 300px;
        // padding-right: 5px;
        border: 1px solid #dedede;
        background-color: #fff;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

        .user-tree-add{
            margin-bottom: 10px;
            .add-node{
                font-size: 14px
            }
        }
        .system-tree {
            padding-top: 20px;
            .tongbu {
                position: absolute;
                top: 3px;
                right: 16px;
                padding: 5px;
                cursor: pointer;
                i {
                    color: #22B9FF;
                }
                &:hover {
                    i {
                        color: darken(#22B9FF,10%);
                    }
                }
                &.loading {
                    transition: all .5s ease-in-out;
                    transform: rotate(2turn);
                }
            }
        }
        .user-tree, .system-tree {
            height: 100%;
            overflow-x: hidden;
            .el-tree-node__content{
                line-height: 42px;
                .tree_node_op{
                    display: none;
                    .nucfont{
                        color: #999;
                        font-size: 14px;
                        padding-left: 2px;
                        padding-right: 2px;
                        &:hover{
                            color: #18c2a0;
                        }
                    }
                }
                &:hover{
                    .tree_node_op{
                        display: inline-block;
                    }
                }
            }
        }

    }

    .map-list-box {
        position: relative;
        display: flex;
        flex-direction: column;
        flex: 1;
        margin-bottom: 15px;
        min-height: 0;

        .map-list {
            padding-right: 10px;
            flex: 1;
            background-color: #fff;
            overflow-y: auto;
        }

        .map-list-outer {
            float: left;
            padding: 8px;
            //width: 16.6%;
            width: 10%;

            @media screen and (max-width: 1440px) {
                width: 20%;
            }
        }
    }

    .need-click-node {
        position: absolute;
        top: 45%;
        left: 50%;
        transform: translate(-50%, -50%);
        /deep/ .el-empty__description p {
            font-size: 16px;
        }
    }

    $map-bg: #f1f5fa;
    $map-select-border: #90c3fd;

    .map-item {
        position: relative;
        margin: 0  auto;
        width: 95%;
        border: 1px solid #dcdfe6;
        z-index: 1;
        cursor: pointer;

        .map-detail {
            padding: 5px 0;
            transition: all .3s;
            &:hover {
                background-color: #e9f3ff;
            }
        }

        .img-wrap {
            width: 90%;
            position: relative;
            padding-top: 70%;
            margin: 0 auto;

            .map-item-img {
                position: absolute;
                top: 55%;
                left: 50%;
                transform: translate(-50%, -50%);
                max-width: 100%;
                max-height: 100%;
            }
        }

        .map-item-name {
            margin: 5px 5px 0 5px;
            font-size: 14px;
            height: 20px;
            line-height: 20px;
            text-align: center;
            @include no-wrap();
        }

        .el-checkbox {
            position: absolute;
            display: none;
            top: 8px;
            right: 0;
            margin: 0;

            &.is-checked {
                display: block;
            }
        }

        .operate-list {
            display: flex;
            background-color: #fcfcfc;
            border-top: 1px solid #e8e8e8;
            border-radius: 0 0 4px 4px;

            li {
                padding: 10px 0;
                flex: 1;
                font-size: 14px;
                color: rgba(0,0,0,.45);
                text-align: center;
                &:not(:last-child) > p {
                    border-right: 1px solid #e8e8e8;
                }
                &:hover {
                    color: #1890ff;
                }
            }
        }

        &.active {
            border-color: #90c3fd;
            .map-detail {
                background-color: #e9f3ff;
            }
        }
    }

    .btn-active {
        background-color: #22B9FF;
        color: #fff;
    }

    .btn-not-active {
        background-color: #fff;
        color: #606266;
        border-color: #dcdfe6;
        &:hover {
            color: #22B9FF;
            border-color: #bdeaff;
            background-color: #e9f8ff;
        }
    }

    //用户图形库下方提醒
    .user-image-tip{
        margin-bottom: 14px;
        padding: 0 12px;
        height: 32px;
        line-height: 32px;
        background-color: #eee;
        border-radius: 4px;
        .check-node{
            font-size: 12px;
            color: #666;
            @include no-wrap();
            .icon-folder {
                font-size: 16px;
                margin-right: 4px;
                vertical-align: -1px;
            }
            span:last-child {
                font-weight: 600;
            }
        }
        .check-tip{
            color: #22B9FF
        }
    }

    .animated {
        -webkit-animation-duration: .3s;
        animation-duration: .3s;
        -webkit-animation-fill-modeprevFile: both;
        animation-fill-mode: both;
    }
    .slot-t-node{
        position: relative;
        z-index: 1;
        .node-name{
            padding-right: 3px;
            >.nucfont {
                margin-right: 4px;
            }
            .folder-type{
                margin-right: 4px;
                font-size: 16px;
                &.folder{
                    color: #ffcc00
                }
                &.image{
                    color: #00bcd4
                }
                &.share{
                    color: #a18fe8
                }
            }
            &.copy-move{
                .folder-type.folder,.folder-type.share{
                    color: #999
                }
            }
        }
        .title {
            font-size: 13px;
        }
        &.node-batch {
            .title {
                font-weight: 600;
            }
            .nucfont {
                color: $color-theme;
            }
        }

        &.current-node {
            .title {
                font-weight: 600;
            }
            &:after {
                content: '';
                position: absolute;
                top: -4px;
                bottom: -4px;
                left: -999px;
                right: -999px;
                background-color: #d5edf9;
                z-index: -1;
            }
        }
        &.node-disabled {
            color: #ccc;
            .image {
                color: #ccc;
            }
            &:after {
                content: '';
                position: absolute;
                top: -4px;
                bottom: -4px;
                left: -999px;
                right: -999px;
                cursor: not-allowed;
            }
        }
    }
    .choose-tip{
        color: #00bcd4;
        margin: 1px 10px 15px 10px;
        font-size: 13px;
        .nucfont{
            font-size:12px
        }
    }
    .node-selected{
        margin-top: 15px;
        margin-left: 10px;
        margin-bottom: 10px;
        color : #999;
    }
    .edit-image-form{
        margin-right: 40px;
    }

    .nodata {
        position: absolute;
        top: 50%;
        width: 100%;
        transform: translateY(-50%);
        text-align: center;
        color: #aaa;
        font-size: 16px;
        i {
            margin-right: 5px;
            color: #aaa;
        }
    }

</style>

<style lang="scss">
    @import '../../style/const.scss';
        @include scrollbar();
    .pageMap {
        .map-tree {
            .el-tabs__content{
                height: 95%;
                padding: 10px 5px;
                overflow: auto;
            }

            .el-tree-node__content {
                position: relative;
            }
            .el-tree-node__expand-icon {
                position: relative;
                z-index: 2;
            }
        }
    }

    .mapDetailPage {
        .box-card {
            display: flex;
            flex-direction: column;
            height: 100%;

            > .el-card__body {
                display: flex;
                flex-direction: column;
                flex: 1;
            }
            .el-tabs__content {
                height: 100%;
            }
        }
    }

    // 学员配置该页面的额外css
    #app-student .pageMap {
        width: 75%;
        min-width: 1200px;
        margin: 0 auto;

        .page-query {
            margin-bottom: 0;
            box-shadow: none;
        }
        .page-table {
            margin-bottom: 20px;
            box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
            .map-list-box {
                border-color: #dedede;
            }
        }
        .map-tree {
            padding-top: 10px;
            height: auto;
            margin-top: 84px;
            margin-bottom: 20px;
            border: none;
            box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
        }
    }

</style>
